import React, { useEffect } from "react";
import { isFileSizeValid } from "../utils";
import { ImageSizeValidation } from "../constants";
import { uploadFiles } from "../../../../services/scanUpload";
import { useDispatch, useSelector } from "react-redux";
import { updatehotel } from "../../../../services/hotel";
import { updateHotel } from "../../../../reducer/loginReducer";
import { message } from "antd";
import UploadFile from "../../upload";
import NavigatingButtons from "../navigatingButtons";

const DocumentsVerification = ({ incrementId, decrementId }) => {
  const [pan, setPan] = React.useState({ name: "", size: "", url: "" });
  const [gst, setGst] = React.useState({ name: "", size: "", url: "" });
  const [bank, setBank] = React.useState({ name: "", size: "", url: "" });

  const { hotelDetails } = useSelector((store) => store.login);
  const dispatch = useDispatch();

  const handleImageBeforeUpload = async (file) => {
    if (!isFileSizeValid(file, 20, ImageSizeValidation.lessThan20mb)) {
      message.error("File size must be lesser than 20 mb");
      return false;
    } else return true;
  };

  // to store file and to get its  url
  const upload = async (file, set, obj) => {
    const data = new FormData();
    data.append("file", file);

    let response = await uploadFiles(data);

    if (Boolean(response)) {
      set({ ...obj, url: response });
    }
  };

  const panUpload = (options) => {
    const file = options.file;

    const data = {
      ...pan,
      name: file.name,
      size: file.size,
    };
    setPan(data);
    upload(file, setPan, data);
  };

  const gstUpload = (options) => {
    const file = options.file;

    const data = {
      ...gst,
      name: file.name,
      size: file.size,
    };
    setGst(data);
    upload(file, setGst, data);
  };

  const bankUpload = (options) => {
    const file = options.file;

    const data = {
      ...bank,
      name: file.name,
      size: file.size,
    };

    setBank(data);
    upload(file, setBank, data);
  };

  const updateHotelDetails = async (e) => {
    e.preventDefault();

    const payload = {
      hotelId: hotelDetails?.id,
      body: {
        ...hotelDetails,
        onBoardingStep: 2,
        panCard: pan.url,
        gstCertificate: gst.url,
        bankAccountDetails: bank.url,
      },
    };

    const response = await updatehotel(payload);

    if (Boolean(response)) {
      dispatch(updateHotel(response.data));
      incrementId();
    } else {
      message.error("Something went wrong");
    }
  };

  useEffect(() => {
    if (hotelDetails?.panCard) {
      const url = hotelDetails.panCard;
      const fileName = url.split("_")[1];

      const data = {
        ...pan,
        name: fileName,
        url: url,
      };
      setPan(data);
    }
    if (hotelDetails?.bankAccountDetails) {
      const url = hotelDetails.bankAccountDetails;
      const fileName = url.split("_")[1];

      const data = {
        ...bank,
        name: fileName,
        url: url,
      };
      setBank(data);
    }
    if (hotelDetails?.gstCertificate) {
      const url = hotelDetails.gstCertificate;
      const fileName = url.split("_")[1];

      const data = {
        ...gst,
        name: fileName,
        url: url,
      };
      setGst(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotelDetails]);

  return (
    <div>
      <div className="flex justify-between items-center">
        <h2 className="text-[2rem] font-[600] uppercase text-[#4f4f4f]">
          Documents Verification
        </h2>
      </div>
      <div className="grid md:grid-cols-3 grid-cols-1 mt-[40px] gap-40">
        <div className="col-span-2">
          <p className="text-[1.125rem] text-[500] font-[500] text-[#323F4B]">
            Submit documents for verification
          </p>
          <p className="text-[#323F4B] text-[1rem] font-[400] font-[nunito] opacity-75">
            Only pdf, jpeg, png documents allowed. (Max 20 MB)
          </p>

          <form onSubmit={updateHotelDetails} className="mt-[56px]">
            <div className="flex w-[60vw] justify-between items-center mb-[36px]">
              <div className="text-lg w-[30%] text-[#535353] whitespace-wrap">
                Pan Card
              </div>

              <div className="w-[20%]">
                <UploadFile
                  handleImageBeforeUpload={handleImageBeforeUpload}
                  handleUpload={panUpload}
                ></UploadFile>
              </div>

              <p className="text-lg text-[#535353] ml-[45px] w-[50%]">
                {pan.name}{" "}
                {pan.size && "(" + Math.ceil(pan.size / 1024) + "KB)"}
              </p>
            </div>

            <div className="flex  w-[60vw] justify-between items-center mb-[36px]">
              <div className="text-lg w-[30%] text-[#535353] whitespace-wrap">
                GST Certificate
              </div>

              <div className="w-[20%]">
                <UploadFile
                  handleImageBeforeUpload={handleImageBeforeUpload}
                  handleUpload={gstUpload}
                ></UploadFile>
              </div>

              <p className="text-lg w-[50%] text-[#535353] ml-[45px]">
                {gst.name}{" "}
                {gst.size && "(" + Math.ceil(gst.size / 1024) + "KB)"}
              </p>
            </div>

            <div className="flex  w-[60vw] justify-between items-center mb-[36px]">
              <div className="text-lg  w-[30%] text-[#535353] whitespace-wrap">
                Bank Account Details
              </div>

              <div className="w-[20%]">
                <UploadFile
                  handleImageBeforeUpload={handleImageBeforeUpload}
                  handleUpload={bankUpload}
                ></UploadFile>
              </div>

              <div className="text-lg  w-[50%] text-[#535353] ml-[45px]">
                {bank.name}{" "}
                {bank.size && "(" + Math.ceil(bank.size / 1024) + "KB)"}
              </div>
            </div>

            <NavigatingButtons decrementId={decrementId}></NavigatingButtons>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DocumentsVerification;
